import * as React from 'react';
import * as _ from 'underscore';

import { CommonStyles } from './CommonStyles';

export interface Props {
  searchTerm: string;
  text: string;
  matchPrefixesOnly: boolean;
  style?: any;
  title?: string;
}

export function escapeRegexp(queryToEscape: string): string {
  return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
}

export function FormattedMatch(props: Props) {
  const formattedMatchStyle = _.extend({}, CommonStyles.Box, props.style);

  if (!props.searchTerm.trim()) {
    return React.createElement('span', { style: formattedMatchStyle, title: props.title }, props.text);
  }

  const escapedSearchTerm = escapeRegexp(props.searchTerm);

  // constructs a regex that will match any word in the search term
  const regex = (props.matchPrefixesOnly ? '(^|\\s+)' : '') + '(' + _.compact(escapedSearchTerm.split(' ')).join('|') + ')';
  const formattedMatch: React.ReactNode[] = [];
  const regExp = new RegExp(regex, 'gi');
  let matchArr: RegExpExecArray;

  // The index at which the next match will start.
  let lastIndex = 0;

  // Iterate through each match in the text.
  for (; (matchArr = regExp.exec(props.text)) !== null; lastIndex = regExp.lastIndex) {

    // add everything between the previous and current match as plain text.
    const beforeMatch = props.text.slice(lastIndex, matchArr.index);
    formattedMatch.push(beforeMatch);

    // add the match itself and make it strong.
    formattedMatch.push(React.createElement('strong', { key: lastIndex.toString() }, matchArr[0]));
  }

  // add the remainder of the text after the final match as plain text.
  formattedMatch.push(props.text.slice(lastIndex, props.text.length));

  return React.createElement('span', { style: formattedMatchStyle, title: props.title }, _.compact(formattedMatch));
}
